module.exports = __webpack_public_path__ + "media/Aceite.5163e632.mp3";